import styled from 'styled-components';

export const StyledBadge = styled.div.withConfig({
  shouldForwardProp: (prop) => !['uppercase'].includes(prop),
})`
  width: fit-content;
  padding-inline: 12px;
  border-radius: 9px;
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : '')};

  &.primary {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.badgePrimary};
    font-size: 18px;
  }

  &.news {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.badgeNews};
    font-size: 18px;
  }

  &.counter {
    position: relative;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.badgePrimary};
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    padding: 4px 8px;
    min-width: 55px;
    text-align: center;

    &.has-notification::after {
      content: 'new';
      background-color: ${({ theme }) => theme.colors.badgeDot};
      color: ${({ theme }) => theme.colors.white};
      font-size: 8px;
      font-family: ${({ theme }) => theme.fontset.titillium};
      font-weight: 600;
      width: 23px;
      height: 11px;
      line-height: 11px;
      aspect-ratio: 1;
      border-radius: 3px;
      position: absolute;
      top: -5.5px;
      right: -4px;
    }

    &.active {
      background-color: ${({ theme }) => theme.colors.badgeActive} !important;
    }
  }

  &.white {
    color: ${({ theme }) => theme.colors.textPrimary};
    background-color: ${({ theme }) => theme.colors.white};
    font-size: 18px;
  }

  &.outline {
    color: ${({ color }) => color};
    border: 1px solid ${({ color }) => color};
    font-size: 16px;

    &.active {
      background-color: ${({ theme }) => theme.colors.badgeActive} !important;
      color: ${({ theme }) => theme.colors.white} !important;
      border: 1px solid ${({ theme }) => theme.colors.white} !important;
    }
  }

  &.dashed {
    color: ${({ theme }) => theme.colors.badgeDashedText};
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    border: 1px dashed ${({ theme }) => theme.colors.badgeDashedBorder};
    padding: 8px 12px;
  }

  &.expired {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.expired};
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    padding: 8px 12px;
  }
`;
